import React, { useEffect, useState } from "react";
import KpiCard from "../../CommonComponents/Dashboard/KpiCard/KpiCard";
import { KPI_CARD_BACKGROUND } from "../../../utils/Constants";

import "./stylesTopSection.css";
import createPrivateAdminPanelInstance from "../../../api/PrivateAdminPanelInstance";
import CustomDatePicker from "../../CommonComponents/CustomDatePicker/CustomDatePicker";

import dayjs from "dayjs";

function TopSection({
  isApiRunning,
  setIsApiRunning,
  overallData,
  setOverallData,
  isTopSectionFirstRender,
  topSectionDates,
  setTopSectionDates,
}) {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken,
    true
  );

    const todayRange = [dayjs(), dayjs()];
    const formattedTodayRange = `start_date=${todayRange[0].format(
      "YYYY-MM-DD"
    )}&end_date=${todayRange[1].format("YYYY-MM-DD")}`;

  const getOverallData = async (queryString) => {
    setIsApiRunning(true);

    if (!queryString) {
      queryString = formattedTodayRange;
    }
    const url = "dashboard/finance/overall?" + queryString;

    try {
      const response = await PrivateAdminPanelInstance?.get(url);
      const data = response?.data.data;
      setOverallData(data);
    } catch (error) {
      console.log("error getting overall data", error);
    } finally {
      setIsApiRunning(false);
    }
  };

  useEffect(() => {
    if (isTopSectionFirstRender.current) {
      getOverallData();
      isTopSectionFirstRender.current = false;
    }
  }, []);

  return (
    <div className="kpi-cards">
      <CustomDatePicker
        getData={getOverallData}
        dates={topSectionDates}
        setDates={setTopSectionDates}
      />
      <div className="top">
        <h3>Net of Deposits and Redemptions</h3>
        <div className="kpi-cards-top-body">
          <div className="left-content">
            <KpiCard
              isApiRunning={isApiRunning}
              title="TOTAL DEPOSITS"
              value={`${overallData?.net_deposit_and_redemptions?.deposit?.current}`}
              hugeValue={false}
              percentage={
                overallData?.net_deposit_and_redemptions?.deposit
                  ?.percentage_change
              }
              backgroundColor={KPI_CARD_BACKGROUND.LIGHT}
            />

            <KpiCard
              isApiRunning={isApiRunning}
              title="Total Prize Redemptions"
              value={`${overallData?.net_deposit_and_redemptions?.redemption?.current}`}
              hugeValue={false}
              percentage={
                overallData?.net_deposit_and_redemptions?.redemption
                  ?.percentage_change
              }
              backgroundColor={KPI_CARD_BACKGROUND.LIGHT}
            />
          </div>

          <div className="right-content">
            <KpiCard
              isApiRunning={isApiRunning}
              title="Net difference"
              value={`${overallData?.net_deposit_and_redemptions?.net_difference?.current}`}
              hugeValue={true}
              percentage={
                overallData?.net_deposit_and_redemptions?.net_difference
                  ?.percentage_change
              }
              backgroundColor={KPI_CARD_BACKGROUND.TRASNPARENT}
            />

            {/* <div className="line-graph-container">
              <Line data={data} options={options} />
            </div> */}
          </div>
        </div>
      </div>
      <div className="bottom">
        <div className="left-content">
          <div className="top-content">
            <KpiCard
              isApiRunning={isApiRunning}
              title="Total rebet cash balance"
              value={`${overallData?.total_rebet_cash_balance?.total_rebet_cash?.current}`}
              hugeValue={true}
              percentage={
                overallData?.total_rebet_cash_balance?.total_rebet_cash
                  ?.percentage_change
              }
              backgroundColor={KPI_CARD_BACKGROUND.TRASNPARENT}
            />

            {/* <div className="line-graph-container">
              <Line data={data} options={options} />
            </div> */}
          </div>
          <div className="bottom-content">
            <KpiCard
              isApiRunning={isApiRunning}
              title="Non-wagered Rebet Cash"
              value={`${overallData?.total_rebet_cash_balance?.total_not_wagered_rebet_cash?.current}`}
              hugeValue={false}
              percentage={
                overallData?.total_rebet_cash_balance
                  ?.total_not_wagered_rebet_cash?.percentage_change
              }
              backgroundColor={KPI_CARD_BACKGROUND.LIGHT}
            />
            <KpiCard
              isApiRunning={isApiRunning}
              title="Redeemable Rebet Cash"
              value={`${overallData?.total_rebet_cash_balance?.total_redeemable_rebet_cash?.current}`}
              hugeValue={false}
              percentage={
                overallData?.total_rebet_cash_balance
                  ?.total_redeemable_rebet_cash?.percentage_change
              }
              backgroundColor={KPI_CARD_BACKGROUND.LIGHT}
            />
          </div>
        </div>
        <div className="right-content">
          <div className="top-content">
            <KpiCard
              isApiRunning={isApiRunning}
              title="GGR"
              value={`${overallData?.ggr?.current}`}
              hugeValue={false}
              percentage={overallData?.ggr?.percentage_change}
              backgroundColor={KPI_CARD_BACKGROUND.DARK}
            />
            <KpiCard
              isApiRunning={isApiRunning}
              title="Deposit Conversion Rate"
              value={`${overallData?.deposit_conversion_rate?.current}`}
              hugeValue={false}
              rate={true}
              percentage={
                overallData?.deposit_conversion_rate?.percentage_change
              }
              backgroundColor={KPI_CARD_BACKGROUND.DARK}
            />
          </div>
          <div className="bottom-content">
            {/* <KpiCard
                isApiRunning={isApiRunning}
              title="Total Affiliate Money Owed"
              value="$15,329"
              hugeValue={false}
              percentage={10}
              backgroundColor={KPI_CARD_BACKGROUND.DARK}
            /> */}
            <KpiCard
              isApiRunning={isApiRunning}
              title="bets"
              value={`${overallData?.total_bets?.current}`}
              hugeValue={false}
              percentage={overallData?.total_bets?.percentage_change}
              backgroundColor={KPI_CARD_BACKGROUND.DARK}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default TopSection;
